<template>
<v-select ref="type" :loading="loading" :items="items" :value="internalValue" item-text="title" item-value="value" v-bind="$attrs" v-on="$listeners" :rules="requiredRules" @input="updateValue" />
</template>

<script>
export default {
  name: 'MyTransferType',
  props: {
    value: {
      required: true,
    },
    route: {}, // در صورت نیاز
  },
  data() {
    return {
      loading: false,
      items: [],
      internalValue: this.value, // reactive copy از prop
      requiredRules: [
        v => !!v || 'فیلد اجباری',
      ],
    }
  },
  watch: {
    value(newVal) {
      this.internalValue = newVal
    }
  },
  methods: {
    async retrieveData() {
      this.loading = true
      try {
        this.items = [{
            value: 't2t',
            title: 'طرف حساب به طرف حساب(پولی)'
          },
          // {
          //   value: 'p2p',
          //   title: 'طرف حساب به طرف حساب(کالا)'
          // },
          {
            value: 'x2b',
            title: 'صندوق به حساب بانکی'
          },
          {
            value: 'b2x',
            title: 'حساب بانکی به صندوق'
          },
          {
            value: 'b2b',
            title: 'حساب بانکی به حساب بانکی'
          },
          {
            value: 'c2t',
            title: 'هزینه به طرف حساب'
          },
          {
            value: 't2i',
            title: 'طرف حساب به درامد'
          }
        ]
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },
    updateValue(v) {
      this.internalValue = v
      this.$emit('input', v)
    }
  },
  async created() {
    await this.retrieveData()
  },
  mounted() {
    this.$refs.type?.focus()
  }
}
</script>
